module.exports = __webpack_public_path__ + "img/qr-code-scan-icon.c8b40576.svg";